import {PlayerId} from '@glark-newco/game-library';
import {useCallback} from 'react';
import {useUIStore} from './useSignlinesUIStore';

export const useFacilitatorOptions = () => {
    // TODO - streamline interactions between the component and the store
    //  It's difficult to reason about when this hook triggers re-renders
    //  The co-mingling of selectors and mutators is ... unsettling.

    // ---- static selectors (hook calls at top level) ----
    const dealStrategy = useUIStore(state => state.dealStrategy);
    const setDealStrategy = useUIStore(state => state.setDealStrategy);
    const addSelectedPlayer = useUIStore(state => state.addSelectedPlayer);
    const removeSelectedPlayer = useUIStore(state => state.removeSelectedPlayer);
    const selectedPlayersTiles = useUIStore(state => state.selectedPlayersTiles);
    const giveSelectedPlayersTiles = useUIStore(state => state.giveSelectedPlayersTiles);

    // ---- derived values that do NOT call hooks inside a function ----
    const selectedPlayersLength = Object.keys(selectedPlayersTiles).length;

    // Helper that reads the store *without* using a hook (safe for any call site)
    const isPlayerSelected = useCallback((playerId: PlayerId) => {
        return Object.prototype.hasOwnProperty.call(selectedPlayersTiles, playerId);
    }, [selectedPlayersTiles]);

    const getTilesAssignedToPlayer = useCallback((playerId: PlayerId) => {
        return selectedPlayersTiles[playerId] ?? [];
    }, [selectedPlayersTiles]);

    // ---- return the same public shape as before ----
    return {
        dealStrategy,
        setDealStrategy,
        addSelectedPlayer,
        removeSelectedPlayer,
        selectedPlayersTiles,
        isPlayerSelected,
        selectedPlayersLength,
        getTilesAssignedToPlayer,
        giveSelectedPlayersTiles,
    };
};
